import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { OwnAdministrativeFeeDetailDto } from '../models/ownadministrativefeedetaildto';
import { PaginationFeaturesDto } from '../models/paginationfeaturesdto';
import { AppConfigService } from './core/appConfig.service';

@Injectable({
    providedIn: 'root'
})
export class OwnAdministrativeFeeDetailService {

    constructor(private http: HttpClient, private configService:AppConfigService) { }

    /**
     * Función encargada de listar todas las tasas administrativas segun filtro
     * @param type
     * @param filter
     * @returns 
     */
    getListOwnAdministrativeFeeDetailById(pageRequest: PaginationFeaturesDto, idOwnAdministrativeFee: number): Observable<any> {
        const params = new HttpParams()
            .set('page', pageRequest.page)
            .set('sizePage', pageRequest.sizePage)
            .set('orderField', pageRequest.orderField)
            .set('order', pageRequest.order);
        const url = `${this.configService.apiUrl}/configuration/own-management-fee/detail/getAll?${params}&idOwnAdministrativeFee=${idOwnAdministrativeFee}`;
        return this.http.get<any>(url).pipe(map(response => { return response; }));
    }

    getOwnAdministrativeFeeDetailById(id: number): Observable<OwnAdministrativeFeeDetailDto> {
        const url = `${this.configService.apiUrl}/configuration/own-management-fee/detail/filter/${id}`;
        return this.http.get<any>(url).pipe(map(response => { return new OwnAdministrativeFeeDetailDto(response); }));
    }

    insertOwnAdministrativeFeeDetail(ownAdministrativeFee: OwnAdministrativeFeeDetailDto): Observable<OwnAdministrativeFeeDetailDto> {
        const url = `${this.configService.apiUrl}/configuration/own-management-fee/detail/insert`;
        return this.http.post<any>(url, ownAdministrativeFee).pipe(map(response => { return new OwnAdministrativeFeeDetailDto(response); }));
    }

    updateOwnAdministrativeFeeDetail(ownAdministrativeFee: OwnAdministrativeFeeDetailDto): Observable<OwnAdministrativeFeeDetailDto> {
        const url = `${this.configService.apiUrl}/configuration/own-management-fee/detail/update`;
        return this.http.put<any>(url, ownAdministrativeFee).pipe(map(response => { return new OwnAdministrativeFeeDetailDto(response); }));
    }

    cloneOwnAdministrativeFeeDetail(ownAdministrativeFeeId: number): Observable<OwnAdministrativeFeeDetailDto> {
        const url = `${this.configService.apiUrl}/configuration/own-management-fee/detail/duplicate/${ownAdministrativeFeeId}`;
        return this.http.post<any>(url, OwnAdministrativeFeeDetailDto).pipe(map(response => { return response; }));
    }

}